export default "__VITE_ASSET__0fd13fcf__"